import styled from "styled-components";

export const CardContainer = styled.div`
  box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.20);
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  background-color: ${({ theme }) =>
    theme.name === "dark" ? "#2A2A2A" : "#f1f2f4"};
  border: 0.71px solid ${({ theme }) => theme.border.black10};
  display: flex;
  flex-direction: ${({ isOneColumn }) => (isOneColumn ? "row" : "column")};
  justify-content: ${({ isOneColumn }) =>
    isOneColumn ? "flex-start" : "space-between"};
  height: 100%;
`;

export const CardCover = styled.div`
  background: url(${({ imageUrl }) => imageUrl});
  background-size: cover;
  background-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  position: relative;

  ${({ isOneColumn }) =>
    isOneColumn
      ? `
      width: 284px;
      height: 241px;
      `
      : `
      height: 170px;
  `}
`;

export const CardOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    ${({ isOneColumn }) => (isOneColumn ? "90deg" : "180deg")},
    ${({ theme }) => (theme.name === "dark" ? "#2A2A2A" : "#f1f2f4")}00 0%,
    ${({ theme }) => (theme.name === "dark" ? "#2A2A2A" : "#f1f2f4")}33 41%,
    ${({ theme }) => (theme.name === "dark" ? "#2A2A2A" : "#f1f2f4")}e6 80%,
    ${({ theme }) => (theme.name === "dark" ? "#2A2A2A" : "#f1f2f4")}ff 91%
  );
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  justify-content: ${({ isOneColumn }) =>
    isOneColumn ? "space-around" : "flex-start"};
  padding: ${({ isOneColumn }) => (isOneColumn ? "24px 40px" : "12px 14px")};
  flex: ${({ isOneColumn }) => (isOneColumn ? 1 : "0 0 auto")};
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ isOneColumn }) => (isOneColumn ? "0px" : "8px")};
`;

export const CardHeading = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.text.input};
  max-width: 70%;
  padding-top: ${({ isOneColumn }) => (isOneColumn ? "0px" : "22px")};
  font-size: ${({ isOneColumn }) => (isOneColumn ? "32px" : "22px")};
  font-weight: 500;
`;

export const CardParagraph = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.text.text};
  width: 80%;
  white-space: pre-wrap;
  opacity: 0.6;
`;

export const CardLabel = styled.span`
  padding: 5px 10px;
  font-size: 12px;
  color: ${({ color }) => color};
  background: ${({ background }) => background};
  border-radius: 9999px;
  width: fit-content;
  height: 26px;
  box-sizing: border-box;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: ${({ hasLabel }) => (hasLabel ? "space-between" : "end")};
  align-items: center;
`;

export const CardArrowContainer = styled.div`
  opacity: 0.6;

  ${({ isAbsolute }) =>
    isAbsolute &&
    `
    position: absolute;
    bottom: 12px;
    right: 14px;
  `}
`;
